import {
    APPLY_SYF_START,
    DECRYPT_SYF_RESULT_START,
    SYF_APPLICATION_WALLET_ADD,
    SYF_APPLICATION_GOTO_REFERRER,
    SYF_APPLICATION_GOTO_WALLET,
    TRACK_SYF_VANITY_PAGE_LOAD,
} from '../actionTypes/ApplySyfActionTypes';

export const startSyfApplication = (
    dataHref,
    { isContinuedAsGuest, toOpenInNewTab, referrer, fromVanityPage } = {}
) => ({
    type: APPLY_SYF_START,
    payload: {
        dataHref,
        isContinuedAsGuest,
        toOpenInNewTab,
        referrer,
        fromVanityPage,
    },
});

export const startDecryptSyfResult = (sdp) => ({
    type: DECRYPT_SYF_RESULT_START,
    payload: {
        sdp,
    },
});
export const gotoReferrer = () => ({
    type: SYF_APPLICATION_GOTO_REFERRER,
});

export const addToWallet = (forGotoWallet = false) => ({
    type: SYF_APPLICATION_WALLET_ADD,
    payload: {
        forGotoWallet,
    },
});

export const gotoWallet = () => ({
    type: SYF_APPLICATION_GOTO_WALLET,
});

export const trackVanityPageLoad = (pageName) => ({
    type: TRACK_SYF_VANITY_PAGE_LOAD,
    payload: {
        pageName,
    },
});
